module.exports = __webpack_public_path__ + "img/lk.b33dbf15.png";